module.exports = __webpack_public_path__ + "static/media/mysticdiva_1920.df44836d.jpg";